import { VERDICT_LABELS, VERDICT_ORDER } from '../constants';
import styles from '../style.module.scss';
import { type ScoredRow, type Verdict } from '../types';

interface ScorecardGridProps {
  rows: ScoredRow[];
  onSelect: (n: number, verdict: Verdict) => void;
}

export function ScorecardGrid({ rows, onSelect }: ScorecardGridProps) {
  return (
    <div className={styles.gridScroll}>
      <table className={styles.grid}>
        <thead>
          <tr>
            <th scope="col" className={styles.colNum}>
              #
            </th>
            <th scope="col">Pillar</th>
            <th scope="col">Test</th>
            <th scope="col">Essential</th>
            {VERDICT_ORDER.map((v) => (
              <th scope="col" key={v} className={styles.colChoice}>
                {VERDICT_LABELS[v]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.n} data-essential={row.essential || undefined}>
              <td className={styles.colNum}>{row.n}</td>
              <td className={styles.pillar}>{row.pillar}</td>
              <th scope="row" className={styles.testName}>
                {row.test}
              </th>
              <td className={styles.essentialCell}>
                {row.essential ? (
                  <span className={styles.essentialMark} title="Essential test">
                    <span className={styles.visuallyHidden}>Essential test</span>
                    <svg width="24" height="24" viewBox="0 0 40 40" fill="none" aria-hidden="true">
                      <circle
                        cx="19.7526"
                        cy="19.7526"
                        r="18.3276"
                        fill={`url(#scGlow${row.n})`}
                        stroke="#471A34"
                        strokeWidth="2.85"
                      />
                      <line
                        x1="10.3693"
                        y1="21.9615"
                        x2="15.4061"
                        y2="26.9984"
                        stroke="#471A34"
                        strokeWidth="2.85"
                        strokeLinecap="round"
                      />
                      <line
                        x1="28.5157"
                        y1="13.9767"
                        x2="15.4501"
                        y2="27.0424"
                        stroke="#471A34"
                        strokeWidth="2.85"
                        strokeLinecap="round"
                      />
                      <defs>
                        <radialGradient
                          id={`scGlow${row.n}`}
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(34.8796 35.2329) rotate(-128.813) scale(45.2169 88.9255)"
                        >
                          <stop stopColor="#FC945B" />
                          <stop offset="0.266209" stopColor="#F0D281" />
                          <stop offset="0.57749" stopColor="#E4D7D2" />
                          <stop offset="1" stopColor="#A2C69D" />
                        </radialGradient>
                      </defs>
                    </svg>
                  </span>
                ) : null}
              </td>
              {VERDICT_ORDER.map((v) => (
                <td key={v} className={styles.choiceCell}>
                  <label className={styles.choice}>
                    <input
                      type="radio"
                      className={styles.choiceInput}
                      name={`ai-scorecard-row-${row.n}`}
                      value={v}
                      checked={row.verdict === v}
                      onChange={() => onSelect(row.n, v)}
                      aria-label={`${row.test} — ${VERDICT_LABELS[v]}`}
                    />
                    <span className={styles.box} data-verdict={v} aria-hidden="true" />
                  </label>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
